import { render, staticRenderFns } from "./ExtendButton.vue?vue&type=template&id=5a754da7&"
import script from "./ExtendButton.vue?vue&type=script&lang=ts&"
export * from "./ExtendButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports